import toastMessage from "../toastMessage";
import { getStorage } from "../storage";
import language from "../../language";
import moment from "moment";
import { ROLE_VITAL_SIGNS } from "../../constants/ROLES";
import { defineRole } from "../handleAccessRoles";
import api from "../api";
// eslint-disable-next-line no-unused-vars

const API_URL = process.env.REACT_APP_BBMS_BASE_API;

export const fetchVitalSignsQuery = async (
  lng = "english",
  {
    page,
    limit,
    id,
    equipment,
    type,
    donor,
    center,
    centerSite,
    vitalSignNumber,
    status,
  }
) => {
  try {
    const user = await getStorage();

    const canAccess = defineRole({
      roles: user.accessRole,
      menu: ROLE_VITAL_SIGNS,
      operation: "read,readOnAction",
    });

    if (!canAccess) return;

    const options = {
      method: "GET",
      url: `${API_URL}/vitalSign`,
      params: {
        page: page,
        limit: limit,
        id,
        equipment,
        donor,
        center,
        centerSite,
        vitalSignNumber: vitalSignNumber !== "" ? vitalSignNumber : undefined,
        status,
      },
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    };

    const queryRes = await api(options);

    if (type === "dropdown") {
      const items = Array.isArray(queryRes.data?.data)
        ? queryRes.data.data
        : Array.isArray(queryRes.data)
        ? queryRes.data
        : [];
      return items.map((el) => ({
        ...el,
        label: moment(el?.preDonationAssessment?.requestedDate).format("lll"),
        value: el._id,
      }));
    }

    let { data, count, totalRecords } = queryRes.data;

    return !page && !limit ? queryRes.data : { data, count, totalRecords };
  } catch (error) {
    toastMessage("error", error);
  }
};

export const deleteVitalSign = async (lng = "english", id) => {
  try {
    const user = await getStorage();

    const canAccess = defineRole({
      roles: user.accessRole,
      menu: ROLE_VITAL_SIGNS,
      operation: "delete",
    });

    if (!canAccess) return;

    const options = {
      method: "DELETE",
      url: `${API_URL}/vitalSign`,
      data: {
        id,
      },
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    };

    await api(options);

    toastMessage("success", language[lng].success_delete_data);
  } catch (error) {
    toastMessage("error", error);
  }
};
